import React from 'react'

export const BottomBar = () => <div id="bottom-bar" />
